import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Globe, LockSimple } from '@phosphor-icons/react';
import { updateUserData } from '@/utils/auth';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const OPTIONS = [
  { value: 'public', label: 'Public', icon: Globe, hint: 'Anyone can view your profile, stats and leaderboard rank.' },
  { value: 'private', label: 'Private', icon: LockSimple, hint: 'Only you and your saved friends can see your profile. You appear as “Private player” on the leaderboard.' },
];

export const PrivacySettings = ({ visibility, onChanged }) => {
  const [saving, setSaving] = useState(false);
  const current = visibility || 'public';

  const choose = async (value) => {
    if (value === current || saving) return;
    setSaving(true);
    try {
      await axios.put(`${API}/users/me/privacy`, { profile_visibility: value });
      updateUserData({ profile_visibility: value });
      toast.success(`Profile is now ${value}`);
      onChanged?.(value);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not update visibility');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-3" data-testid="profile-visibility-section">
      <h3 className="text-sm font-medium text-[#71717A] uppercase tracking-wider">Profile Visibility</h3>
      <div className="grid grid-cols-2 gap-4" role="radiogroup" aria-label="Profile visibility">
        {OPTIONS.map(({ value, label, icon: Icon, hint }) => {
          const active = current === value;
          return (
            <button key={value} type="button" role="radio" aria-checked={active} disabled={saving} onClick={() => choose(value)}
              className={`p-4 border text-left transition-colors disabled:opacity-60 ${active ? 'border-[#0047FF] bg-[#0047FF]/5' : 'border-[#E4E4E7] bg-white hover:bg-[#FAFAFA]'}`}
              data-testid={`visibility-option-${value}`}>
              <div className="flex items-center gap-2 mb-1">
                <Icon size={18} weight={active ? 'fill' : 'regular'} className={active ? 'text-[#0047FF]' : 'text-[#71717A]'} />
                <span className={`font-medium ${active ? 'text-[#0047FF]' : 'text-[#09090B]'}`}>{label}</span>
              </div>
              <p className="text-xs text-[#71717A] leading-relaxed">{hint}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};
